// Access injected environment variables and config from window globals
// These are injected by the component-server during build time

export const process = {
    env: window.__ENV__ || {},
};

export const config = window.__CONFIG__ || {};

// Make them available globally for backward compatibility
if (typeof window !== "undefined") {
    window.process = process;
    window.config = config;

    // Also make process.env available directly for backward compatibility
    window.process.env = process.env;
}
